<template>
  <div class="search-container">
    <div class="news-list">
      <div
        v-for="(item,index) in newsList"
        :key="index"
        class="news-item"
      >
        <div class="title">
          <span class="link" @click="jumpNewsDetail(item.id,item.customUrl)">
            {{ item.title }}
          </span>
        </div>
        <div class="time">{{ item.publishTime | parseTime('{y}-{m}-{d} {h}:{m}:{s}') }}</div>
        <div class="content">
          <span @click="jumpNewsDetail(item.id,item.customUrl)"> {{ handlerStr(item.content) }}</span>
        </div>
        <div class="normal">
          <span class="jump" @click="jumpNewsDetail(item.id,item.customUrl)">详情</span>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="prev, pager, next, total"
        :current-page.sync="pagination.pageNo"
        :page-size.sync="pagination.pageSize"
        :total.sync="pagination.total"
        :hide-on-single-page="!newsList.length"
        @current-change="pageChange"
      />
    </div>
    <noData v-if="!pagination.total" />
  </div>
</template>

<script>
import { getArticleList } from '@/api/common';
import noData from '@/components/no-data.vue';
import { deleteHtmlTag, handlerStr } from '@/utils';
export default {
  components: {
    noData
  },
  data() {
    return {
      newsList: [],
      searchParams: {
        title: ''
      },
      pagination: {
        total: -1,
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(urlInfo) {
        this.resetParams();
        this.searchParams.title = urlInfo.query.title;
        this.getNewsList();
      }
    }
  },
  methods: {
    getNewsList() {
      const { pageNo, pageSize } = this.pagination;
      const { title } = this.searchParams;
      const data = this.buildParams({
        pageNo,
        pageSize,
        title
      });
      getArticleList(data).then(res => {
        if (!res.data) {
          this.newsList = [];
          this.pagination.total = 0;
          return;
        }
        this.newsList = res.data.rows;
        this.pagination.total = res.data.total;
      });
    },
    resetParams() {
      this.searchParams = {
        title: ''
      };
    },
    pageChange(value) {
      this.getNewsList()
      window.scrollTo({ top: 0 });
    },
    handlerStr(str) {
      return str && handlerStr(deleteHtmlTag(str), 200)
    },
    jumpNewsDetail(id, customUrl) {
      if (customUrl) {
        var windowOpen = window.open()
        windowOpen.location = customUrl;
      } else {
        this.$router.push({
          path: '/news',
          query: {
            id
          }
        })
      }
    }
  }
};
</script>

<style lang="less" scoped>
.search-container {
  .news-list {
    clear: both;
    background: #fff;
    margin-bottom: 15px;
    .news-item{
      padding: 40px;
    }
    .link {
      font-size: 18px;
      line-height: 30px;
      color: #333333;
      font-family: 宋体;
      font-weight: bold;
      &:hover{
        color: #CC3300;
      }
    }
    .time {
      font-size: 12px;
      color: #9b9b9b;
      line-height: 30px;
    }
    .content{
      color: #9B9B9B;
      line-height: 20px;
      font-size: 14px;
      &:hover{
        color: #2386e2;
        text-decoration: underline;
      }
    }
    .normal{
      font-size: 12px;

      color: #9B9B9B;
      line-height: 30px;
      clear: both;
      .jump{
        padding: 0 20px 0 20px;
        border: 1px solid #ccc;
        float: right;
        &:hover{
          color: #fff;
          background: #CC3300;
        }
      }
    }
  }
  .pagination-wrapper{
    display: flex;
    justify-content: center;
  }
}
</style>
